import React from "react";
import {ServerStyleSheet} from "styled-components";

/**
 * styled-components SSR style collector for vite-react-ssg.
 *
 * vite-react-ssg ships its own `style-collectors/styled-components`, but that module is resolved by
 * Node at render time and therefore imports a *different* styled-components instance than the app —
 * which is bundled into the SSR output (see `ssr.noExternal` in vite.config.ts). A separate
 * `ServerStyleSheet` instance can't see the app's styled components, so no CSS gets collected and the
 * pre-rendered HTML ships without styled-components rules (FOUC).
 *
 * Defining the collector here, inside the app's own (bundled) module graph, guarantees the
 * `ServerStyleSheet` shares the exact styled-components instance the components render with, so the
 * generated CSS is correctly inlined into each pre-rendered page.
 */
export default function styledComponentsCollector() {
	const sheet = new ServerStyleSheet();
	return {
		collect(app: React.ReactElement): React.ReactElement {
			return sheet.collectStyles(app);
		},
		toString(): string {
			return sheet.getStyleTags();
		},
		cleanup(): void {
			sheet.seal();
		},
	};
}
